import { ShapeType } from "./wbcontroller/types/ShapeType";
import ToolType from "./wbcontroller/types/ToolType";

export enum WidgetType {
  StrokeWidth = "StrokeWidth",
  StrokeWidthForEraser = "StrokeWidthForEraser",
  StrokeColor = "StrokeColor",
  FillColor = "FillColor",
  FillColorForSticky = "FillColorForSticky",
  Opacity = "Opacity",
  DeleteSelection = "DeleteSelection",
  DuplicateSelection = "DuplicateSelection",
}

export function getWidgetTypes(
  tool: ToolType,
  selectedShapeTypes: ShapeType[]
): Set<WidgetType> {
  const types = new Set(selectedShapeTypes);
  const isJustSticky = types.size === 1 && types.has(ShapeType.Node);
  const isJustText = types.size === 1 && types.has(ShapeType.Text);
  switch (tool) {
    case ToolType.Text:
    case ToolType.Pan:
    case ToolType.Stamp:
      return new Set([]);
    case ToolType.Sticky:
      return new Set([WidgetType.FillColorForSticky]);
    case ToolType.Eraser:
      return new Set([WidgetType.StrokeWidthForEraser]);
    case ToolType.Arrow:
    case ToolType.Line:
    case ToolType.Pen:
      return new Set([WidgetType.StrokeWidth, WidgetType.StrokeColor]);
    case ToolType.Marker:
      return new Set([
        WidgetType.StrokeWidth,
        WidgetType.StrokeColor,
        WidgetType.Opacity,
      ]);
    case ToolType.Rect:
    case ToolType.Ellipse:
    case ToolType.Diamond:
      return new Set([
        WidgetType.StrokeWidth,
        WidgetType.StrokeColor,
        WidgetType.FillColor,
      ]);
    case ToolType.Select:
      if (isJustSticky) {
        return new Set([
          WidgetType.FillColorForSticky,
          WidgetType.DeleteSelection,
          WidgetType.DuplicateSelection,
        ]);
      } else if (isJustText) {
        return new Set([
          WidgetType.DeleteSelection,
          WidgetType.DuplicateSelection,
        ]);
      } else {
        return new Set([
          WidgetType.StrokeWidth,
          WidgetType.StrokeColor,
          WidgetType.FillColor,
          WidgetType.DeleteSelection,
          WidgetType.DuplicateSelection,
        ]);
      }
    default:
      return new Set([]);
  }
}
